import { render } from "./selectedParts.vue?vue&type=template&id=4d7f0fa9"
import script from "./selectedParts.vue?vue&type=script&lang=js"
export * from "./selectedParts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__